module.exports = __webpack_public_path__ + "static/media/captcha_identifier.1f0405ce.gif";